import { RunState } from "types/generated";

type RunSummaryPromptArguments = {
  stackId: string;
  runId: string;
};

type PhaseSummaryPromptArguments = {
  stackId: string;
  runId: string;
  state: RunState;
};

export const buildRunSummaryPrompt = ({ stackId, runId }: RunSummaryPromptArguments): string =>
  `Summarize Spacelift run \`${runId}\` in stack \`${stackId}\` — explain what happened and surface any errors and how to fix them.`;

export const buildPhaseSummaryPrompt = ({
  stackId,
  runId,
  state,
}: PhaseSummaryPromptArguments): string => {
  const phaseName = state.toLowerCase().replace(/_/g, " ");

  return `Summarize the ${phaseName} phase of Spacelift run \`${runId}\` in stack \`${stackId}\` — surface any execution errors and how to fix them.`;
};
